import { useSelector, useDispatch, useStore } from 'react-redux';

const useBookmarks = () => {
  const store = useStore();
  const byType = useSelector(store.select.bookmarks.byType);

  const dispatch = useDispatch();

  const create = async payload => {
    await dispatch.bookmarks.create(payload);
  };

  return {
    ...byType,
    load: dispatch.bookmarks.load,
    create,
  };
};

export default useBookmarks;
